module.exports = __webpack_public_path__ + "media/packs/images/state/pick-7266b9dcd8806123058bd2bd3561b9d3.svg";